<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M40.99 44.61L37.29 40.91C36.73 41.21 36.11 41.39 35.43 41.39C35.43 42.49 34.53 43.39 33.43 43.39C32.33 43.39 31.43 42.49 31.43 41.39H19.43C19.43 42.49 18.53 43.39 17.43 43.39C16.33 43.39 15.43 42.49 15.43 41.39C13.23 41.39 11.43 39.59 11.43 37.39V15.39C11.43 15.29 11.47 15.19 11.47 15.09L4.20996 7.83001L7.02996 5.01001L43.79 41.77L40.99 44.61ZM33.77 37.39L26.93 30.55L23.93 27.55L20.43 24.05L17.43 21.05L15.43 19.05V37.39H33.77ZM39.43 15.39V31.73L35.43 27.73V15.39H23.09L19.43 11.73V5.39001C19.43 4.29001 20.33 3.39001 21.43 3.39001H29.43C30.53 3.39001 31.43 4.29001 31.43 5.39001V11.39H35.43C37.63 11.39 39.43 13.19 39.43 15.39ZM22.43 11.39H28.43V6.39001H22.43V11.39Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
